import React from 'react';
import { useNavigate } from 'react-router-dom';
import { soundManager } from '../utils/SoundManager';
import historyOneTrainersData from '../data/HistoryOne';
import './HistoryOne.css';

const HistoryOneTrainers = () => {
    const navigate = useNavigate();

    // Convert trainer data object to array
    const trainers = Object.values(historyOneTrainersData);

    // Handle trainer selection
    const handleTrainerSelect = (trainer) => {
        console.log('⚔️ Ancient Conqueror trainer selected:', trainer.name);

        // 🎵 TRAINER SELECTION SOUND
        soundManager.playButtonSound();

        // Navigate to individual trainer page
        navigate(`/history-trainer/${trainer.id}`);
    };

    // Handle back navigation
    const handleBackToCategories = () => {
        soundManager.playButtonSound();
        navigate('/history-train-categories');
    };

    return (
        <div className="history-trainers-container">
            <div className="history-animated-background"></div>

            {/* Back Button */}
            <button
                className="back-to-categories-button"
                onClick={handleBackToCategories}
            >
                ← Back to Categories
            </button>

            {/* Header */}
            <div className="history-trainers-header">
                <div className="header-content">
                    <h1>Ancient Conquerors & Empire Builders</h1>
                    <p>Train with legendary generals, emperors, and world conquerors</p>
                    <div className="category-stats">
                        <span className="stat-badge">Trainers: {trainers.length}</span>
                        <span className="stat-badge">Programs: {trainers.length * 6}</span>
                        <span className="stat-badge">Category: Ancient History</span>
                    </div>
                </div>
            </div>

            {/* Trainers Grid */}
            <div className="history-trainers-grid">
                {trainers.map((trainer, index) => (
                    <div
                        key={trainer.id}
                        className="history-trainer-card floating-empire-element"
                        onClick={() => handleTrainerSelect(trainer)}
                        data-character={trainer.id}
                        style={{
                            '--history-primary-color': trainer.color,
                            '--history-secondary-color': trainer.secondaryColor
                        }}
                    >
                        {/* Crown accent */}
                        <div className="crown-accent"></div>

                        {/* Trainer Image */}
                        <div className="history-trainer-image-section">
                            <div
                                className="history-trainer-image"
                                style={{
                                    backgroundImage: `url(${trainer.image})`
                                }}
                            >
                                <div className="empire-glow-effect"></div>
                                <div className="experience-badge history-badge">
                                    {trainer.experience}
                                </div>
                            </div>
                        </div>

                        {/* Trainer Info */}
                        <div className="history-trainer-info-section">
                            <h3 className="history-trainer-name">{trainer.name}</h3>
                            <p className="history-trainer-specialization">{trainer.specialization}</p>
                            <p className="history-trainer-description">{trainer.intro}</p>

                            <div className="history-trainer-details">
                                <div className="detail-item history-detail">
                                    <div className="detail-icon">👑</div>
                                    <div className="detail-text">Programs: {trainer.programs.length}</div>
                                </div>
                                <div className="detail-item history-detail">
                                    <div className="detail-icon">⚔️</div>
                                    <div className="detail-text">{trainer.experience}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Empire Divider */}
            <div className="empire-divider"></div>

            {/* Footer */}
            <div className="history-trainers-footer">
                <div className="history-info">
                    <h3>Ancient Conquerors & Empire Builders Philosophy</h3>
                    <div className="history-benefits-grid">
                        <div className="history-benefit-item">
                            <div className="benefit-icon">🛡️</div>
                            <div>
                                <strong>Phalanx Formation Power</strong>
                                <p>Unstoppable synchronized strength that breaks through any resistance like Alexander's legendary formations</p>
                            </div>
                        </div>
                        <div className="history-benefit-item">
                            <div className="benefit-icon">🏛️</div>
                            <div>
                                <strong>Roman Legion Discipline</strong>
                                <p>Military precision and political domination that built the greatest empire in history</p>
                            </div>
                        </div>
                        <div className="history-benefit-item">
                            <div className="benefit-icon">🐘</div>
                            <div>
                                <strong>Tactical Genius</strong>
                                <p>Mountain-crossing innovation that turns every disadvantage into strategic victory</p>
                            </div>
                        </div>
                        <div className="history-benefit-item">
                            <div className="benefit-icon">🏹</div>
                            <div>
                                <strong>Nomadic Lightning War</strong>
                                <p>Continental terror tactics that make entire civilizations surrender without fighting</p>
                            </div>
                        </div>
                        <div className="history-benefit-item">
                            <div className="benefit-icon">🎯</div>
                            <div>
                                <strong>Artillery Emperor Precision</strong>
                                <p>Mathematical accuracy combined with revolutionary innovation that reshapes civilizations</p>
                            </div>
                        </div>
                        <div className="history-benefit-item">
                            <div className="benefit-icon">📚</div>
                            <div>
                                <strong>Intellectual Supremacy</strong>
                                <p>Nine-language brilliance that conquers the greatest minds through charisma and wisdom</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HistoryOneTrainers;